// extracted by mini-css-extract-plugin
module.exports = {"container":"faq-module--container--1BHD_","title":"faq-module--title--mzs_h","accContainer":"faq-module--accContainer--1WXA8"};